import React, { useState, useEffect, useRef, useMemo } from 'react';
import {
  Container,
  Input,
  Label,
  Button,
  CustomInput,
  Row,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  FormGroup
} from 'reactstrap';
import { connect } from 'react-redux';
import { ICommissionHistoryTable, ICommissionHistoryTableRedux } from '../../types/interfaces';

import { editCommissionCom, editCommissionFormula } from '../../flux/actions/commissionhistoryActions';
import TableContainer from "../tables_manager/TableContainer"
import DoubleSwitchCell from '../tables_manager/DoubleSwitchCell'
import CommissionCommentEdit from './CommissionCommentEdit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalculator, faCheck, faCheckCircle, faCommentDots, faDownload, faExpandArrowsAlt, faExternalLinkAlt, faEye, faFileInvoice, faMoneyCheck, faPen, faPrint, faRedo, faSpinner, faThumbtack, faUndo, faUserEdit } from '@fortawesome/free-solid-svg-icons'
import moment from "moment";
import { useHistory } from 'react-router-dom';
import { useAlert } from "react-alert";

import { DateRangeColumnFilter, NumberRangeColumnFilter, SelectColumnFilter } from '../tables_manager/filters';
import Loading from '../Loading';
import PDFLink from '../pdf/PDFLink';
import Select from 'react-select';
import { getVenteByIdPromise } from '../../flux/actions/venteActions';
import { E_ERROR } from '../../types/errors';
import { getCommissionType, getCommissionWarning, getEncStatut } from "../../services/misc";
import { betterTypeName } from '../../services/formatting';
import { PRIVILEGE } from '../../types/privileges';
import EditableCell from '../tables_manager/EditableCell';
import { constants } from '../../types/constants';

const CommissionHistoryTable = ({ 
  linesData,
  setTableData,
  setFilteredRows,
  selectedRows,
  setSelectedRows,
  clearFilters,
  setClearFilters,
  clearRowsKey,
  showProjectColumn,
  showComColumn,
  editCommissionCom,
  editCommissionFormula,
  users,
  formulas,
  formula_societe_defaults,
  societes,
  formatFormula,
  auth
 }: ICommissionHistoryTable) => {
  const history = useHistory();
  const alert = useAlert();
  const skipResetRef = useRef(false);
  const userOptions = (users || []).map(e => ({value: e, label: e.username}));
  const [editComModal, setEditComModal] = useState(false);
  const [modalEditComData, setModalEditComData] = useState<any[]>([]);
  const [editFormulaModal, setEditFormulaModal] = useState(false);
  const [modalEditFormulaData, setModalEditFormulaData] = useState<any[]>([]);
  const [modalFormula, setModalFormula] = useState(false);
  const [modalFormulaData, setModalFormulaData] = useState<any>('');
  const [formattedFormula, setFormattedFormula] = useState<any>('');
  const [idValues, setIdValues] = useState<any[]>([]);
  const [userValue, setUserValue] = useState<any>('');
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [reEnable, setReEnable] = useState(false);
  const [idValuesF, setIdValuesF] = useState<any[]>([]);
  const [selectedFormulaId, setSelectedFormulaId] = useState(-1);
  const [disableSubmitF, setDisableSubmitF] = useState(false);
  const [reEnableF, setReEnableF] = useState(false);
  const [showSelection, setShowSelection] = useState(false);
  const [editCommentModal, setEditCommentModal] = useState(false);
  const [modalEditCommentData, setModalEditCommentData] = useState('');
  const formulasData = (formulas || []).map(e => formatFormula(e))
  const [highlightTag, setHighlightTag] = useState<any>(undefined);
  const [tagsArePinned, setTagsArePinned] = useState(true);
  
  const handleToggleCom = () => setEditComModal(!editComModal);
  const handleToggleChangeFormula = () => setEditFormulaModal(!editFormulaModal);

  const modalOpenedHandle = () => {
    // if(modalEditComData && modalEditComData !== ''){
    setIdValues(modalEditComData.map(e => e.id));
    if(modalEditComData.length > 0 && modalEditComData.every((v, i, a) => i === 0 || v.comId === a[i - 1].comId))
      setUserValue(userOptions.find(e => e.value?.id === Number(modalEditComData[0].comId || 0))?.value || '')
    else
      setUserValue('')
  };

  const modalClosedHandle = () => {
    setIdValues([]);
    setUserValue('');
    if(reEnable){
      setDisableSubmit(false);
      setReEnable(false);
    }
  };

  const modalOpenedHandleChangeFormula = () => {
    // if(modalEditFormulaData && modalEditFormulaData !== ''){
    setIdValuesF(modalEditFormulaData.map(e => e.id));
    if(modalEditFormulaData.length > 0 && modalEditFormulaData.every((v, i, a) => i === 0 || v.formulaId === a[i - 1].formulaId))
      setSelectedFormulaId(modalEditFormulaData[0].formulaId);
    else
      setSelectedFormulaId(-1)
  };

  const modalClosedHandleChangeFormula = () => {
    setIdValuesF([]);
    setSelectedFormulaId(-1);
    if(reEnableF){
      setDisableSubmitF(false);
      setReEnableF(false);
    }
  };

  const handleUserChange = data => {
    setUserValue(data ? data.value : '');
  };
  
  const handleToggleFormula = () => setModalFormula(!modalFormula);

  const changeShowSelectionHandle = (e) => {
    setShowSelection(e.target.checked)
  };

  useEffect(() => {
    if(modalFormulaData)
      setFormattedFormula(formatFormula(modalFormulaData))
  }, [modalFormulaData])

  const callback = (success) => {
    if(success){
      setReEnable(true);
      setEditComModal(false);
      alert.success("Bénéficiaire changé avec succès");
      return
    }
    alert.error("Une erreur s'est produite");
    setDisableSubmit(false);
  }

  const editHandle = async () => {
    if(!userValue || userValue === ''){
      alert.error("Veuillez sélectionner un commercial");
      return
    }

    setDisableSubmit(true);
    editCommissionCom(idValues, userValue.id, auth?.user?.id, callback);
  };

  const callbackF = (success) => {
    if(success){
      setReEnableF(true);
      setEditFormulaModal(false);
      alert.success("Méthode de calcul changée avec succès");
      return
    }
    alert.error("Une erreur s'est produite");
    setDisableSubmitF(false);
  }

  const editFormulaHandle = async () => {
    if(!selectedFormulaId){
      alert.error("Veuillez sélectionner une méthode de calcul");
      return
    }

    setDisableSubmitF(true);
    editCommissionFormula(idValuesF, selectedFormulaId, auth?.user?.id, callbackF);
  };

  const columns = useMemo(() => [
    ...(!showComColumn && !!auth?.user?.privileges?.includes(PRIVILEGE.VALIDATE_COMMISSIONS) ? [{
      Header: "Valider",
      accessor: "accepted_table",
      Cell: e => (!e.row.original.isDangerRow || auth?.user?.id === 8) && DoubleSwitchCell({...e, prefix: "ar_commissions", firstVar: "accepted_table", secondVar: "rejected_table"}),
      className: "text-center",
      disableFilters: true,
    },
    {
      Header: "Rejeter",
      accessor: "rejected_table",
      Cell: e => (!e.row.original.isDangerRow || auth?.user?.id === 8) && DoubleSwitchCell({...e, prefix: "ar_commissions", firstVar: "accepted_table", secondVar: "rejected_table", isDanger: true}),
      className: "text-center",
      disableFilters: true,
    }] : []),
    {
      Header: "Commission",
      accessor: "commission_init",
      Filter: NumberRangeColumnFilter,
      filter: 'between',
      className: "text-center",
      Footer: e => {
        const total = useMemo(
          () =>
            e.rows.reduce((e, row) => e + (row.values.commission_init || 0) + (row.values.bonus_malus_table || 0), 0),
          [e.rows]
        )

        // return <div style={{textAlign: "right", fontWeight: 600, fontSize: "large"}}><span>Total:</span>&nbsp;<span style={{color: total > 0 ? "green" : "red"}}>{total.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Dh</span></div>
        return <div style={{display: "flex", justifyContent: "space-between"}}>
          <div>Total: </div>
          <div style={{textAlign: "right", fontWeight: 600, fontSize: "large", color: total > 0 ? "green" : "red"}}>{total.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH</div>
        </div>
      },
      Cell: ({ value, row: {original} }) => <>
        {(value + original.bonus_malus_table) !== 0 ? <div className="cardSticker" style={{textAlign: "center", color: "white", backgroundColor: (value + original.bonus_malus_table) > 0 ? "darkgreen" : "darkred"}}>{(value + original.bonus_malus_table) > 0 && "+"}{(value + original.bonus_malus_table).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH</div> : "-"}
        {!!(value !== undefined && original.bonus_malus_table !== 0) && <div style={{textAlign: "center", fontSize: "x-small", color: value > 0 ? "darkgreen" : "darkred"}}>(de {value > 0 && "+"}{value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH)</div>}
      </>
    },
    {
      Header: "Commission à payer",
      accessor: "commission",
      Filter: NumberRangeColumnFilter,
      filter: 'between',
      className: "text-center",
      Cell: (e) => <>
        {!!(e.row.original.commission !== 0) && EditableCell({...e, isDouble: true, maximumToShow: e.row.original.commission_init, maximumLimit: e.row.original.QTE_INIT_TABLE, isQuantity: true, addInitialValue: true, ignoreMaximumLimit: false})}
        {!!(e.row.original.commission !== e.row.original.commission_init) && (!!(e.row.original.commission === 0 && e.row.original.commission_init !== 0) ? <>
            <div className="cardSticker" style={{backgroundColor: "cornflowerblue"}}>totalement validée</div>
            {!!e.row.original.commission_bulletin_lines?.some(e => /*(e.commission_bulletin?.paid || 0) > 0*/!!e.commission_bulletin?.commission_payments?.length) && <>
              {!!e.row.original.commission_bulletin_lines?.every(e => !!e.commission_bulletin?.commission_payments?.length) ? 
                <div className="cardSticker" style={{backgroundColor: "darkgreen"}}>totalement payée</div>
                : <div className="cardSticker" style={{backgroundColor: "darkgreen", opacity: .8}}>partiellement payée</div>
              }
            </>}
          </> : <>
            <div className="cardSticker" style={{backgroundColor: "cornflowerblue", opacity: .8, marginTop: "3px"}}>partiellement validée</div>
            {!!e.row.original.commission_bulletin_lines?.some(e => /*(e.commission_bulletin?.paid || 0) > 0*/!!e.commission_bulletin?.commission_payments?.length) && <>
              {!!e.row.original.commission_bulletin_lines?.every(e => !!e.commission_bulletin?.commission_payments?.length) ? 
                <div className="cardSticker" style={{backgroundColor: "darkgreen"}}>totalement payée</div>
                : <div className="cardSticker" style={{backgroundColor: "darkgreen", opacity: .8}}>partiellement payée</div>
              }
            </>}
          </>)}
      </>,
    },
    {
      Header: "Bonus/Malus",
      accessor: "bonus_malus_table",
      filter: 'equals',
      className: "text-center minTableCellWidth150",
      Cell: (e) => e.row.original.commission === 0 && e.row.original.commission_init !== 0 ? "-" : EditableCell({...e, isDouble: true, isPrice: true, ignoreMaximumLimit: true}),
    },
    {
      Header: "Alerte",
      id: "Alerte",
      accessor: e => e.rejected === 1 ? "Rejetée" : getCommissionWarning(e.badEnc),
      // accessor: e => e.rejected === 1 ? "Rejetée" : e.badEnc === 1 ? "Autre" : e.badEnc === 2 ? "Sans encaiss." : e.badEnc === 3 ? "Impayé" : e.badEnc === 4 ? "À ne pas verser" : e.badEnc === 5 ? "Non récep." : "",
      customExportDisplay: `$.rejected === 1 ? "Rejetée" : getCommissionWarningHandle($.badEnc)`,
      Filter: SelectColumnFilter,
      filter: 'equals',
      className: "text-center",
      Cell: ({ value, row: {original} }) => <div style={(!!original.badEnc || original.rejected === 1) ? {color: "darkred"} : {}}>{value || "-"}</div>,
    },
    {
      Header: "Observation",
      accessor: "comment",
      className: "text-center",
      Cell: ({ value, row: {original} }) => value ? <div className="tableCommentIcon" style={{opacity: value ? .9 : .2}} title="Voir/Modifier le commentaire de cette ligne" onClick={() => {setModalEditCommentData(original); setEditCommentModal(true)}}>
        <FontAwesomeIcon icon={faCommentDots} />&nbsp;Voir
      </div> : auth?.user?.privileges?.includes(PRIVILEGE.EDIT_COMMISSIONS) ? <div className="tableCommentIcon" style={{opacity: .2}} title="Modifier le commentaire de cette ligne" onClick={() => {setModalEditCommentData(original); setEditCommentModal(true)}}>
        <FontAwesomeIcon icon={faPen} />
      </div> : "-"
    },
    {
      Header: "Bénéficiaire",
      id: "Bénéficiaire",
      accessor: row => row.comUserCommissionHistory?.LOGIN || "",
      customExportDisplay: `$.comUserCommissionHistory ? $.comUserCommissionHistory.LOGIN : ""`,
      Filter: SelectColumnFilter,
      filter: 'equals',
      Cell: ({ value }) => value || "-",
      hidden: !showComColumn
    },
    {
      Header: "Bénéficiaire Vente/Part",
      accessor: row => (row.association ? row.association?.commissionedToAUser?.LOGIN : row.contrat?.commissionedToVUser?.LOGIN) || "",
      // customExportDisplay: `$.contrat && $.contrat.chargeBienUser ? $.contrat.chargeBienUser.LOGIN : ""`,
      Filter: SelectColumnFilter,
      filter: 'equals',
      Cell: ({ value }) => value || "-",
      // hidden: true
    },
    {
      Header: "Chargé du Bien",
      id: "Chargé du Bien",
      accessor: row => row.contrat?.chargeBienUser?.LOGIN || "",
      customExportDisplay: `$.contrat && $.contrat.chargeBienUser ? $.contrat.chargeBienUser.LOGIN : ""`,
      Filter: SelectColumnFilter,
      filter: 'equals',
      Cell: ({ value }) => value || "-",
      // hidden: true
    },
    {
      Header: "Fiche Vente",
      className: "text-center",
      disableSortBy: true,
      disableFilters: true,
      Cell: ({ row: {original} }) => (
          <div className="actionsContainer">
              {original.venteId ? <PDFLink documentType={"vente"}
                func={async () => getVenteByIdPromise(original.venteId || -1)}
                download={false}
                buttonText=""
                iconSize="inherit"
                // customClassNames="btn btn-info"
                customButtonIcon={faFileInvoice}
                allowPrintPreview={true}
                htmlTitle={`Voir la fiche de Vente`}
                customClassNames="btn btn-success btn-rounded btn-sm my-0 waves-effect waves-light"//actionButtonsSpace
                style={{paddingRight: ".75rem", paddingLeft: ".75rem"}} /> : null}
          </div>
      ),
    },
    {
      Header: "Source",
      id: "Source",
      accessor: e => getCommissionType(e.type),
      customExportDisplay: `getCommissionTypeHandle($.type)`,
      // accessor: row => row.type === "V" ? "Vente" : row.type === "A" ? "Association" : row.type === "E" ? "Encaissement non récep." : row.type === "ER" ? "Encaissement réceptionné" : row.type === "EEI" ? "Encaissement à verser" : row.type === "EEncaisse" ? "Encaissement encaissé" : row.type === "EImpaye" ? "Encaissement impayé" : (row.type || ""),
      // customExportDisplay: `$.type === "V" ? "Vente" : $.type === "A" ? "Association" : $.type === "E" ? "Encaissement non récep." : $.type === "ER" ? "Encaissement réceptionné" : $.type === "EEI" ? "Encaissement à verser" : $.type === "EEncaisse" ? "Encaissement encaissé" : $.type === "EImpaye" ? "Encaissement impayé" : ($.type || "")`,
      Filter: SelectColumnFilter,
      filter: 'equals',
      Cell: ({ value }) => <b>{value || "-"}</b>
    },
    {
      Header: "ID",
      accessor: "id",
      hidden: true
    },
    {
      Header: "ID Bien",
      accessor: "bienId",
      hidden: true
    },
    {
      Header: "ID Vente",
      accessor: "venteId",
      hidden: true
    },
    {
      Header: "ID Association",
      accessor: "associationId",
      hidden: true
    },
    {
      Header: "ID Encaissement",
      accessor: "encaissementId",
      hidden: true
    },
    {
      Header: "Projet",
      id: "Projet",
      accessor: row => row.societe?.LIBELE || "",
      customExportDisplay: `($.societe && $.societe.LIBELE ? $.societe.LIBELE : undefined) || ""`,
      Filter: SelectColumnFilter,
      filter: 'equals',
      className: "text-center",
      Cell: ({ value, row: {original} }) => value || "-",
      hidden: !showProjectColumn
    },
    {
      Header: "N° Doss.",
      id: "N° Doss.",
      accessor: e => e.contrat?.NUM_DOSS ? (!isNaN(e.contrat?.NUM_DOSS) ? Number(e.contrat?.NUM_DOSS) : e.contrat?.NUM_DOSS) : "",
      // filter: (rows, id, e) => rows.filter(t => (t.original.contrat_encaissements?.filter((e, index, self) => self.findIndex(t => t.contrat?.id === e.contrat?.id) === index).map(e => e.contrat?.NUM_DOSS || "-") || []).includes(e)),
      // filter: (rows, id, e) => rows.filter(t => t.original.contrat?.NUM_DOSS === e),
      // customExportDisplay: `($.contrat_encaissements && $.contrat_encaissements.length) ? $.contrat_encaissements.filter((e, index, self) => self.findIndex(t => (t.contrat ? t.contrat.id : undefined) === (e.contrat ? e.contrat.id : undefined)) === index).map(t => t.contrat && t.contrat.NUM_DOSS ? t.contrat.NUM_DOSS : "-").join(" / ") : "-"`,
      customExportDisplay: `$.contrat && $.contrat.NUM_DOSS ? $.contrat.NUM_DOSS : ""`,
      filter: 'equals',
      className: "minTableCellWidth90",
      // Cell: ({ row: {original} }) => original.contrat_encaissements?.length ? original.contrat_encaissements.filter((e, index, self) => self.findIndex(t => t.contrat?.id === e.contrat?.id) === index).map(e => e.contrat?.NUM_DOSS || "-").join(" et ") : "-",
      Cell: ({ row: {original} }) => {
        return original.contrat ? <a href={original.contrat?.id !== null && original.contrat?.id !== undefined ? (`/consultation/${original.contrat.id}`) : '/#'} onClick={(e) => {
          e.preventDefault();
          if(original.contrat?.id !== null && original.contrat?.id !== undefined)
            window.open('/consultation/' + original.contrat.id,'_blank')
          else
            alert.error(E_ERROR.NO_VENTE_WITH_THIS_ID)
        }}><button className="openLinkBtn">{original.contrat?.NUM_DOSS || "-"}<FontAwesomeIcon icon={faExternalLinkAlt} className="openLinkIcon" /></button></a> : "-"
      }
    },
    {
      Header: "Désignation",
      id: "Désignation",
      accessor: row => `${row.bien?.DESIGNATION || ""}${row.associationId ? row.association ? ` (${row.association.ETAGE === "0" ? "RDC" : `Étage ${row.association.ETAGE || "-"}`} ${row.association.POURCENTAGE}%${row.association.POSITION ? ` ${row.association.POSITION}` : ""})` : "-Asso-" : ""}`,
      customExportDisplay: `($.bien && $.bien.DESIGNATION ? $.bien.DESIGNATION : "") + ($.associationId ? $.association ? (" (" + ($.association.ETAGE === "0" ? "RDC" : ("Étage " + ($.association.ETAGE || "-"))) + " " + $.association.POURCENTAGE + "%" + ($.association.POSITION ? (" " + $.association.POSITION) : "") + ")") : "-Asso-" : "")`,
      // customExportDisplay: `$.isAssLine ? (($.ETAGE === "0" ? "RDC" : "Étage " + ($.ETAGE ? $.ETAGE : "-")) + " " + $.POURCENTAGE + "%" + ($.POSITION ? (" " + $.POSITION) : "")) : $.DESIGNATION`,
      // accessor: "DESIGNATION",
    },
    // {
    //   Header: "Type",
    //   accessor: row => row.bien?.TYPE?.toLowerCase().includes("app") ? "Appartement" : row.bien?.TYPE?.toLowerCase().includes("mag") ? "Magasin" : (row.bien?.TYPE || ""),
    //   customExportDisplay: `$.bien && $.bien.TYPE ? $.bien.TYPE : "-"`,
    //   Cell: ({ value }) => value || "-"
    // },
    {
      Header: "Type Bien",
      accessor: "typeVente",
      Cell: ({ value }) => value || "-",
      hidden: true
    },
    {
      Header: "Prix Vente",
      id: "Prix Vente",
      accessor: row => row.ventePrice || row.contrat?.PRIX_NET,
      customExportDisplay: `$.ventePrice || ($.contrat && $.contrat.PRIX_NET ? $.contrat.PRIX_NET : "")`,
      filter: 'equals',
      Cell: ({ value }) => (value !== null && value !== undefined && value != "") ? (value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-",
      // hidden: true
    },
    {
      Header: "Prix du Part",
      id: "Prix du Part",
      accessor: row => row.associationPrice || row.association?.PRIX_VENTE,
      customExportDisplay: `$.associationPrice || ($.association && $.association.PRIX_VENTE ? $.association.PRIX_VENTE : "")`,
      filter: 'equals',
      Cell: ({ value }) => (value !== null && value !== undefined && value != "") ? (value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-",
      hidden: true
    },
    {
      Header: "Date Encaissement",
      id: "Date Encaissement",
      accessor: e => e.encaissement?.DATE_REGLEMENT || "",
      Filter: DateRangeColumnFilter,
      filter: "dateBetween",
      customExportDisplay: `$.encaissement && $.encaissement.DATE_REGLEMENT ? new Date($.encaissement.DATE_REGLEMENT) : "-"`,
      Cell: ({ value }) => value ? moment(value).format('DD/MM/YYYY') : "-",
      hidden: true
    },
    {
      Header: "Réf. Règlement",
      id: "Réf. Règlement",
      accessor: row => row.encaissement?.REF_REGLEMENT || "",
      customExportDisplay: `$.encaissement && $.encaissement.REF_REGLEMENT ? $.encaissement.REF_REGLEMENT : ""`,
      Cell: ({ value }) => value || "-"
    },
    {
      Header: "Tiré par",
      id: "Tiré par",
      accessor: row => row.encaissement?.TIRE_PAR || "",
      customExportDisplay: `$.encaissement && $.encaissement.TIRE_PAR ? $.encaissement.TIRE_PAR : ""`,
      Cell: ({ value }) => value || "-",
      hidden: true
    },
    {
      Header: "Montant Encaissé",
      id: "Montant Encaissé",
      accessor: row => row.encaissementPrice || row.encaissement?.MONTANT || row.contrat?.contrat_encaissements?.filter(e => !row.associationId || e.ID_ASS == row.associationId).reduce((e, t) => {return t.PART ? e + t.PART : e}, 0) || 0,
      // customExportDisplay: `$.encaissementPrice || ($.encaissement && $.encaissement.MONTANT ? $.encaissement.MONTANT : "")`,
      filter: 'equals',
      Cell: ({ value, row: {original} }) => {
        if(original.encaissementPrice || original.encaissement?.MONTANT)
          return (value !== null && value !== undefined && value != "") ? (value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-"
        else {
          const prixNet = original.associationId ? Number(original.associationPrice || original.association?.PRIX_VENTE || 0) : Number(original.ventePrice || original.contrat?.PRIX_NET || 0);
          return value ? (<>
            {value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Dh&nbsp;
            {prixNet ? <span className="encPercent" style={{color: "hsl(" + (Math.ceil((value * 100) / prixNet) * 1.2).toString(10) + ", 100%, 50%)"}}>({Math.ceil((value * 100) / prixNet)}%)</span> : null}
          </>) : "-"
        }
      }
    },
    {
      Header: "Banque",
      id: "Banque",
      accessor: row => row.encaissement?.BANQUE || "",
      customExportDisplay: `$.encaissement ? $.encaissement.BANQUE : ""`,
      Filter: SelectColumnFilter,
      filter: 'equals',
      Cell: ({ value }) => value || "-",
      hidden: true
    },
    {
      Header: "Statut Enc.",
      accessor: row => getEncStatut(row.encaissement?.STATUT),
      customExportDisplay: `getEncStatutHandle($.encaissement && $.encaissement.STATUT)`,
      Filter: SelectColumnFilter,
      filter: 'equals',
      Cell: ({ value }) => value || "-",
    },
    ...(!!auth?.user?.privileges?.includes(PRIVILEGE.SEE_COMMISSIONS_FORMULAS) ? [{
      Header: "Méthode de calcul",
      accessor: "formulaId",
      Filter: SelectColumnFilter,
      filter: 'equals',
      Cell: ({ value, row: {original} }) => {
        return (<div style={{minWidth: "120px", position: "relative"}}>
          {/* {value} */}
          <div className="selectableList selectableListMini">
            {(!!original.formula && !!formatFormula(original.formula)) && <div className="selectableListItemNoAni">
              {/* <div className="selectableListHead fullFlexCenter" style={{borderRight: "1px solid #eee", lineHeight: "100%"}}><FontAwesomeIcon icon={faEye} /></div> */}
              <div className="selectableListContent"><div className="selectableListContentDiv">{ formatFormula(original.formula).content }</div></div>
              {!!formatFormula(original.formula).name && <div className="cardSticker selectableListFloatingTitle" title={formatFormula(original.formula).name}>{formatFormula(original.formula).name}</div>}
              {!!formula_societe_defaults?.find(t => t.formulaId === formatFormula(original.formula).id) && <div className="cardSticker selectableListFloatingTitle" style={{backgroundColor: "green", right: "10px", left: "unset", maxWidth: "50%"}} title={`Standard ${formula_societe_defaults.filter(t => t.formulaId === formatFormula(original.formula).id).filter(t => !!societes?.find(n => n.id === t.societeId)).map(t => societes?.find(n => n.id === t.societeId)?.LIBELE || "").join(" - ")}`}>{`Standard ${formula_societe_defaults.filter(t => t.formulaId === formatFormula(original.formula).id).filter(t => !!societes?.find(n => n.id === t.societeId)).map(t => societes?.find(n => n.id === t.societeId)?.LIBELE || "").join(" - ")}`}</div>}
            </div>}
          </div>
          {!!original.formulaId && <div className="formulaTableId" style={{backgroundColor: constants.formulaIdColors[(original.formulaId - 1) % constants.formulaIdColors.length]}}>{original.formulaId}</div>}
          <FontAwesomeIcon icon={faExpandArrowsAlt} className="formulaZoom" title="Agrandir" onClick={() => {
            setModalFormula(true);
            setModalFormulaData(original.formula);
          }} />
        </div>)
      }
    }] : []),
    {
      Header: "Saisie par",
      id: "Saisie par",
      accessor: row => row.commissionedByUser?.LOGIN || "",
      customExportDisplay: `$.commissionedByUser ? $.commissionedByUser.LOGIN : ""`,
      Filter: SelectColumnFilter,
      filter: 'equals',
      Cell: ({ value }) => value || "-",
      hidden: true
    },
    {
      Header: "Saisie le",
      accessor: "createdAt",
      Filter: DateRangeColumnFilter,
      filter: "dateBetween",
      // filter: (rows, id, e) => rows.filter(t => t.original[id] && moment(t.original[id]).format('DD/MM/YYYY').includes(e)),
      customExportDisplay: `$.createdAt ? new Date($.createdAt) : ""`,
      Cell: ({ value }) => value ? <div title={moment(value).format('DD/MM/YYYY - HH:mm')}>{moment(value).locale('fr').calendar({
          sameDay: '[Aujourd\'hui à] HH:mm',
          nextDay: 'DD/MM/YYYY à HH:mm',
          nextWeek: 'DD/MM/YYYY à HH:mm',
          lastDay: '[Hier à] HH:mm',
          lastWeek: 'DD/MM/YYYY à HH:mm',
          sameElse: 'DD/MM/YYYY à HH:mm'
      })}</div> : "-",
      hidden: true
    },
    {
      Header: "Première validation le",
      // accessor: e => e.commission_bulletin_lines?.find(e => !!e)?.commission_bulletin?.createdAt || "",
      accessor: e => e.commission_bulletin_lines?.length ? (e.commission_bulletin_lines[0].commission_bulletin?.createdAt || "") : "",
      Filter: DateRangeColumnFilter,
      filter: "dateBetween",
      // customExportDisplay: `$.createdAt ? new Date($.createdAt) : ""`,
      Cell: ({ value, row: {original} }) => <div className="fullFlexCenter">
        {value ? <div title={moment(value).format('DD/MM/YYYY - HH:mm')}>{moment(value).locale('fr').calendar({
            sameDay: '[Aujourd\'hui à] HH:mm',
            nextDay: 'DD/MM/YYYY à HH:mm',
            nextWeek: 'DD/MM/YYYY à HH:mm',
            lastDay: '[Hier à] HH:mm',
            lastWeek: 'DD/MM/YYYY à HH:mm',
            sameElse: 'DD/MM/YYYY à HH:mm'
        })}</div> : "-"}
        {!!(auth?.user?.privileges?.includes(PRIVILEGE.OTHERS_COMMISSIONS) && original.commission_bulletin_lines?.find(e => !!e)?.commission_bulletin?.id) && <FontAwesomeIcon icon={faEye} className="inTableColumnBtn" title="Voir le bulletin de commission" onClick={() => window.open(`/bulletin_commission/${original.commission_bulletin_lines?.find(e => !!e)?.commission_bulletin?.id}`, '_blank')} />}
      </div>,
      hidden: true
    },
    {
      Header: "Dernière validation le",
      // accessor: e => e.commission_bulletin_lines?.find(e => !!e)?.commission_bulletin?.createdAt || "",
      accessor: e => e.commission_bulletin_lines?.length ? (e.commission_bulletin_lines[e.commission_bulletin_lines.length - 1].commission_bulletin?.createdAt || "") : "",
      Filter: DateRangeColumnFilter,
      filter: "dateBetween",
      // customExportDisplay: `$.createdAt ? new Date($.createdAt) : ""`,
      Cell: ({ value, row: {original} }) => <div className="fullFlexCenter">
        {value ? <div title={moment(value).format('DD/MM/YYYY - HH:mm')}>{moment(value).locale('fr').calendar({
            sameDay: '[Aujourd\'hui à] HH:mm',
            nextDay: 'DD/MM/YYYY à HH:mm',
            nextWeek: 'DD/MM/YYYY à HH:mm',
            lastDay: '[Hier à] HH:mm',
            lastWeek: 'DD/MM/YYYY à HH:mm',
            sameElse: 'DD/MM/YYYY à HH:mm'
        })}</div> : "-"}
        {!!(auth?.user?.privileges?.includes(PRIVILEGE.OTHERS_COMMISSIONS) && original.commission_bulletin_lines?.find(e => !!e)?.commission_bulletin?.id) && <FontAwesomeIcon icon={faEye} className="inTableColumnBtn" title="Voir le bulletin de commission" onClick={() => window.open(`/bulletin_commission/${original.commission_bulletin_lines?.find(e => !!e)?.commission_bulletin?.id}`, '_blank')} />}
      </div>,
      // hidden: true
    },
    {
      Header: "Payée le",
      accessor: e => e.commission_bulletin_lines?.find(e => !!e)?.commission_bulletin?.commission_payments?.find(e => !!e)?.createdAt || "",
      Filter: DateRangeColumnFilter,
      filter: "dateBetween",
      // customExportDisplay: `$.createdAt ? new Date($.createdAt) : ""`,
      Cell: ({ value }) => value ? <div title={moment(value).format('DD/MM/YYYY - HH:mm')}>{moment(value).locale('fr').calendar({
          sameDay: '[Aujourd\'hui à] HH:mm',
          nextDay: 'DD/MM/YYYY à HH:mm',
          nextWeek: 'DD/MM/YYYY à HH:mm',
          lastDay: '[Hier à] HH:mm',
          lastWeek: 'DD/MM/YYYY à HH:mm',
          sameElse: 'DD/MM/YYYY à HH:mm'
      })}</div> : "-",
      hidden: true
    },
    {
      Header: "Date retenue",
      accessor: "dateRetenue",
      Filter: DateRangeColumnFilter,
      filter: "dateBetween",
      // filter: (rows, id, e) => rows.filter(t => t.original[id] && moment(t.original[id]).format('DD/MM/YYYY').includes(e)),
      customExportDisplay: `$.dateRetenue ? new Date($.dateRetenue) : ""`,
      Cell: ({ value }) => value ? <div title={moment(value).format('DD/MM/YYYY')}>{moment(value).locale('fr').calendar({
          sameDay: '[Aujourd\'hui à] HH:mm',
          nextDay: 'DD/MM/YYYY à HH:mm',
          nextWeek: 'DD/MM/YYYY à HH:mm',
          lastDay: '[Hier à] HH:mm',
          lastWeek: 'DD/MM/YYYY à HH:mm',
          sameElse: 'DD/MM/YYYY à HH:mm'
      })}</div> : "-",
      hidden: true
    },
    {
      Header: "Actions",
      className: "text-center",
      Cell: ({ row: {original} }) => (
          <Container className="actionsContainer">
              {!!(auth?.user?.privileges?.includes(PRIVILEGE.EDIT_COMMISSIONS) || (original.comId === auth?.user?.id && (original.commission > 0 || original.commission_init === 0))) && <button className="btn btn-info btn-rounded btn-sm my-0 waves-effect waves-light"
                onClick={(e) => {setModalEditComData([original]); setEditComModal(true)}}
                disabled={original.commission_bulletin_lines?.length}
                // disabled={original.commission !== original.commission_init}
                title={original.commission_bulletin_lines?.length ? "Déjà commissionnée" : "Changer le bénéficiaire"}>
                {/* title={original.commission !== original.commission_init ? "Déjà commissionnée" : "Changer le bénéficiaire"}> */}
                <FontAwesomeIcon icon={faUserEdit} />
              </button>}
              {!!auth?.user?.privileges?.includes(PRIVILEGE.EDIT_COMMISSIONS) && <button className="btn btnB btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                onClick={(e) => {setModalEditFormulaData([original]); setEditFormulaModal(true)}}
                disabled={original.commission_bulletin_lines?.length}
                title={original.commission_bulletin_lines?.length ? "Déjà commissionnée" : "Changer la méthode de calcul"}>
                <FontAwesomeIcon icon={faCalculator} />
              </button>}
          </Container>
      ),
      ...(!!auth?.user?.privileges?.includes(PRIVILEGE.EDIT_COMMISSIONS) ? {
        Footer: e => <div>
          <div className="fullEllipsis"><CustomInput type="switch" id="showSelection" name="showSelectionSwitch" className="switchSmall" label="Afficher les champs de sélection" checked={showSelection} onChange={changeShowSelectionHandle} /></div>
          <div className="fullEllipsis fullFlexCenter" style={{fontSize: "x-small"}}>{`${selectedRows.length} ligne${selectedRows.length > 1 ? "s" : ""} sélectionnée${selectedRows.length > 1 ? "s" : ""}`}</div>
          {!!showSelection && <div className="actionsContainer">
            <button className="btn btn-info btn-rounded btn-sm my-0 waves-effect waves-light"
              onClick={(e) => {setModalEditComData(selectedRows); setEditComModal(true)}}
              disabled={!selectedRows?.length}
              // disabled={!selectedRows.find(e => e.commission_bulletin_lines?.length)}
              // disabled={original.commission !== original.commission_init}
              title={"Changer le bénéficiaire"}>
              {/* title={original.commission !== original.commission_init ? "Déjà commissionnée" : "Changer le bénéficiaire"}> */}
              <FontAwesomeIcon icon={faUserEdit} />
            </button>
            <button className="btn btnB btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
              onClick={(e) => {setModalEditFormulaData(selectedRows); setEditFormulaModal(true)}}
              disabled={!selectedRows?.length}
              title={"Changer la méthode de calcul"}>
              <FontAwesomeIcon icon={faCalculator} />
            </button>
          </div>}
        </div>
      } : {}),
      disableSortBy: true,
    },
  ], [showProjectColumn, showComColumn, auth?.user?.privileges, selectedRows?.length, showSelection]);

  const updateMyData = (rowIndex, columnId, value) => {
    // setSkipPageReset(true);
    skipResetRef.current = true;
    setTableData(old =>
      old.map((row, index) => {
        if (index === rowIndex) {
          return {
            ...old[rowIndex],
            [columnId]: value,
          }
        }
        return row
      })
    )
  }

  React.useEffect(() => {
    // setSkipPageReset(false);
    skipResetRef.current = false;
  }, [linesData])

  return (
    <div>
      <Container>
        <TableContainer columns={columns} data={linesData} dataName="preparation_commissions" showFooter enableCheckBox={showSelection} checkBoxChecksAllPages clearFilters={clearFilters} setClearFilters={setClearFilters} clearRowsKey={clearRowsKey} isEditable ignoreDangerCheckbox setFilteredRows={setFilteredRows} setSelectedRows={setSelectedRows} updateMyData={updateMyData} skipPageReset={skipResetRef.current}/>
      </Container>
      <Modal isOpen={editComModal} toggle={handleToggleCom} onOpened={modalOpenedHandle} onClosed={modalClosedHandle}>
        <ModalHeader toggle={handleToggleCom}><FontAwesomeIcon icon={faUserEdit} />&nbsp;&nbsp;Changement du Bénéficiaire</ModalHeader>
        <ModalBody>
            <Container className="linesConfirmationContainer">
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="user">Bénéficiaire de la commission{modalEditComData?.length === 1 && <>&nbsp;(<b>{(modalEditComData[0].commission || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH</b>)</>}</Label>
                    <Select
                      name="user"
                      className="reactselect"
                      classNamePrefix="react-select"
                      value={userValue ? {label: userValue["username"], value: userValue} : null}
                      onChange={handleUserChange}
                      placeholder={'Chercher par nom...'}
                      isClearable={false}
                      loadingMessage={() => 'Chargement...'}
                      noOptionsMessage={() => 'pas de resultat'}
                      isSearchable={true}
                      options={userOptions}
                      menuContainerStyle={{ zIndex: 9999999 }}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row className="justify-content-center">
                <Button
                  className="btn btn-success linesConfirmationBtn"
                  onClick={editHandle}
                  disabled={disableSubmit}
                  ><FontAwesomeIcon icon={disableSubmit ? faSpinner : faCheckCircle} className={disableSubmit ? "spinner" : ""} />&nbsp;&nbsp;Modifier</Button>
              </Row>
            </Container>
        </ModalBody>
      </Modal>
      <Modal isOpen={editFormulaModal} toggle={handleToggleChangeFormula} onOpened={modalOpenedHandleChangeFormula} onClosed={modalClosedHandleChangeFormula}>
        <ModalHeader toggle={handleToggleChangeFormula}><FontAwesomeIcon icon={faCalculator} />&nbsp;&nbsp;Changement de Méthode de Calcul</ModalHeader>
        <ModalBody>
            <Container className="linesConfirmationContainer">
              <div className="selectableList">
                {formulasData.map((e, key) => <div className="selectableListItem" onClick={() => setSelectedFormulaId(e.id)} key={key}>
                  <div className="selectableListHead"><span style={selectedFormulaId === e.id ? {backgroundColor: "#62af42"} : {}}><FontAwesomeIcon icon={faCheck} style={{color: "white"}} /></span></div>
                  <div className="selectableListContent"><div className="selectableListContentDiv">{ e.content }</div></div>
                  <div className="selectableListArrow"></div>
                  <div className="cardSticker selectableListFloatingTitle" title={e.name}>({e.id || "-"}){e.name ? ` ${e.name}` : ""}</div>
                  {!!formula_societe_defaults?.find(t => t.formulaId === e.id) && <div className="cardSticker selectableListFloatingTitle" style={{backgroundColor: "green", right: "10px", left: "unset", maxWidth: "50%"}} title={`Standard ${formula_societe_defaults.filter(t => t.formulaId === e.id).filter(t => !!societes?.find(n => n.id === t.societeId)).map(t => societes?.find(n => n.id === t.societeId)?.LIBELE || "").join(" - ")}`}>{`Standard ${formula_societe_defaults.filter(t => t.formulaId === e.id).filter(t => !!societes?.find(n => n.id === t.societeId)).map(t => societes?.find(n => n.id === t.societeId)?.LIBELE || "").join(" - ")}`}</div>}
                </div>)}
              </div>
              <Row className="justify-content-center">
                <Button
                  className="btn btn-success linesConfirmationBtn"
                  onClick={editFormulaHandle}
                  disabled={disableSubmitF}
                  ><FontAwesomeIcon icon={disableSubmitF ? faSpinner : faCheckCircle} className={disableSubmitF ? "spinner" : ""} />&nbsp;&nbsp;Modifier</Button>
              </Row>
            </Container>
            {/* <Row className="mt-2 floatingFormulaTags" style={{position: tagsArePinned ? "sticky" : "relative"}}>
              <FontAwesomeIcon icon={faThumbtack} className={`floatingFormulaTagsPin${tagsArePinned ? " floatingFormulaTagsPinned" : ""}`} title={tagsArePinned ? "Détacher" : "Épingler"} onClick={() => setTagsArePinned(e => !e)} />
              {formulaTags.map((e, key) => <Col xs="12" sm="6" style={{fontSize: "small", marginBottom: "2px"}} key={key}>
                {e.tag}&nbsp;<i className="formulaTagDescription" style={highlightTag === e.id ? {backgroundColor: "#0f08"} : {}}>{e.description}</i>
              </Col>)}
            </Row> */}
        </ModalBody>
      </Modal>
      <Modal isOpen={modalFormula} toggle={handleToggleFormula}>
        <ModalHeader toggle={handleToggleFormula}>{formattedFormula?.name ? `"${formattedFormula?.name}"` : ""}</ModalHeader>
        <ModalBody>
          <Container className="linesConfirmationContainer" style={{padding: 0}}>
            <div className="selectableList">
              {!!formattedFormula && <div className="selectableListItemNoAni">
                <div className="selectableListHead fullFlexCenter" style={{borderRight: "1px solid #eee", lineHeight: "100%"}}><FontAwesomeIcon icon={faEye} /></div>
                <div className="selectableListContent"><div className="selectableListContentDiv">{ formattedFormula.content }</div></div>
                {!!formattedFormula.name && <div className="cardSticker selectableListFloatingTitle" title={formattedFormula.name}>{formattedFormula.name}</div>}
                {!!formula_societe_defaults?.find(t => t.formulaId === formattedFormula.id) && <div className="cardSticker selectableListFloatingTitle" style={{backgroundColor: "green", right: "10px", left: "unset", maxWidth: "50%"}} title={`Standard ${formula_societe_defaults.filter(t => t.formulaId === formattedFormula.id).filter(t => !!societes?.find(n => n.id === t.societeId)).map(t => societes?.find(n => n.id === t.societeId)?.LIBELE || "").join(" - ")}`}>{`Standard ${formula_societe_defaults.filter(t => t.formulaId === formattedFormula.id).filter(t => !!societes?.find(n => n.id === t.societeId)).map(t => societes?.find(n => n.id === t.societeId)?.LIBELE || "").join(" - ")}`}</div>}
              </div>}
            </div>
          </Container>
        </ModalBody>
      </Modal>
      <CommissionCommentEdit modal={editCommentModal} setModal={setEditCommentModal} modalData={modalEditCommentData} />
    </div>
  );
};

const mapStateToProps = (state: ICommissionHistoryTableRedux) => ({
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, { editCommissionCom, editCommissionFormula })(CommissionHistoryTable);